import { OverlaySpinner } from '@ankr.com/ui';
import { useMemo, useState } from 'react';

import { useThemes } from 'uiKit/Theme/hook/useThemes';

import { CountriesMap } from './types';
import { StatsMap } from './components/StatsMap';
import { StatsTable, StatsTableProps } from './components/StatsTable';
import { getCountriesList } from './utils/getCountriesList';
import { useRequestsMapStyles } from './useRequestsMapStyles';

export interface RequestsMapProps {
  countries?: CountriesMap;
  dataType?: StatsTableProps['dataType'];
  loading: boolean;
}

export const RequestsMap = ({
  countries,
  dataType,
  loading,
}: RequestsMapProps) => {
  const { classes } = useRequestsMapStyles();
  const [country, setCountry] = useState<string>('');
  const { isLightTheme } = useThemes();

  const data = useMemo(
    () => getCountriesList(countries, isLightTheme, dataType),
    [countries, dataType, isLightTheme],
  );

  return (
    <div className={classes.root}>
      {loading ? (
        <div className={classes.loading}>
          <OverlaySpinner />
        </div>
      ) : (
        <div className={classes.container}>
          <StatsTable
            data={data}
            dataType={dataType}
            selectedCountry={country}
          />
          <div className={classes.mapContainer}>
            <StatsMap data={data} setCountry={setCountry} />
          </div>
        </div>
      )}
    </div>
  );
};
